module.exports = __webpack_public_path__ + "static/img/NSW-18.5dd2448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-18.jpg
// module id = tHFk
// module chunks = 0